import { render, staticRenderFns } from "./ModalInfo.vue?vue&type=template&id=43ea04e0&"
import script from "./ModalInfo.vue?vue&type=script&lang=ts&"
export * from "./ModalInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports